export const ACTIVE_TABS = {
  LEARNING: 'learning',
  CONTENT: 'content',
  RESOURCE: 'resource',
  ADD_NOTE: 'add-note',
  NOTE_LIST: 'note-list',
}
